import React, { useEffect } from "react";
import i18n from "../../i18n/config";
import { ROUTES } from "../../constants/clientRoutes";
import PercentageSplitImg from "../../assets/images/percentage_split.png";
import FixedSplitImg from "../../assets/images/fixed_split.png";
import { WizardChildProps } from "../../types/props";

import SelectAllocationTypeRow from "../../components/Allocations/SelectAllocationTypeRow";

const SelectAllocationType = (props: WizardChildProps) => {
  const { setTitle, setForwardButton } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    setTitle(i18n.t("PAGES.ALLOCATIONS.SELECT_ALLOCATION_TYPE.TITLE"));
    setForwardButton(null);
  }, []);

  return (
    <>
      <p>{i18n.t("PAGES.ALLOCATIONS.SELECT_ALLOCATION_TYPE.SUBTITLE")}</p>

      <SelectAllocationTypeRow
        buttonText={i18n.t("PAGES.ALLOCATIONS.SELECT_ALLOCATION_TYPE.PERCENTAGE_BUTTON_TEXT")}
        imgSrc={PercentageSplitImg}
        route={ROUTES.ALLOCATIONS.PERCENTAGE_SPLIT}
        dataCy="percentage-split-button"
      />

      <hr className="spacing-bottom-medium spacing-top-medium" />

      <SelectAllocationTypeRow
        buttonText={i18n.t("PAGES.ALLOCATIONS.SELECT_ALLOCATION_TYPE.FIXED_BUTTON_TEXT")}
        imgSrc={FixedSplitImg}
        route={ROUTES.ALLOCATIONS.SPECIFIC_AMOUNT}
        dataCy="specific-amount-button"
      />
    </>
  );
}

export default SelectAllocationType;